import { ChangeDetectorRef, Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { UserDealersModel } from 'projects/Administration/src/app/business-entities/dealer-details.model';
import { DealerViewModel } from 'projects/Administration/src/app/business-entities/dealer-view-model';
import { AppointmentService } from 'projects/Administration/src/app/business-services/appointment.service';
import { DealerBusinessService } from 'projects/Administration/src/app/business-services/dealer.service';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { WorkOrderStatusResponseModel } from '../../../business-entities/work-order-status-model';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { UserDataService } from 'src/app/DataServices/user-data.service';

@Component({
  selector: 'app-work-order-status',
  templateUrl: './work-order-status.component.html',
})
export class WorkOrderStatusComponent implements OnInit {

  //#region Variable Declaration
  searchTerm: any;
  dealerList: DealerViewModel[] = [];
  workOrderStatusResponseModel: WorkOrderStatusResponseModel[] = [];
  workOrderStatusListPDF: any[] = [];
  dataList: WorkOrderStatusResponseModel[] = [];
  selectedDate: any[] = [];
  dealerId: string = null;
  totalCount: number = 0;
  scrollDistance = 1;
  throttle = 100;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  myDateRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({},{
    containerClass: 'theme-dark-blue',
    displayMonths:1,
    showWeekNumbers:false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'custom-today-class'
  });

  workOrderStatusRequest = {
    sortColumn: '',
    sortDirection: '',
    StartRecordNumber: 0,
    PageSize: 25,
    LanguageCode: '',
    SearchTerm: '',
    fromDate: '',
    toDate: '',
    selectedDate: '',
    dealerId: '',
    isExport: false,
  };
  //#endregion

  //#region Constructor
  constructor(
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private dealerBusinessService: DealerBusinessService,
    private appointmentService: AppointmentService,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef,
    private excelService: ExcelService,
    private toaster: ToastrService,
    private userService: UserDataService
  ) { }
  //#endregion

  ngOnInit(): void {
    this.dealerId = this.userService.currentUserValue.defaultDealerId;
    this.workOrderStatusRequest.dealerId = this.dealerId;
    this.getDealers();
    this.setDefaultValues();
    this.getWorkOrderStatusDetails();
  }

  //#region Component Methods
  setDefaultValues() {
    let todayDate = new Date();
    let formattedTodayDate = this.datePipe.transform(todayDate, 'dd/MM/yyyy');
    this.selectedDate=[];
    this.selectedDate.push(todayDate);
    this.selectedDate.push(todayDate);
    let formatted= formattedTodayDate + ' - ' + formattedTodayDate;
    this.workOrderStatusRequest.selectedDate = formatted;
    this.workOrderStatusResponseModel = [];
  }

  onSearchFilter() {
    this.workOrderStatusRequest.SearchTerm = this.searchTerm;
    this.workOrderStatusResponseModel = [];
    this.getWorkOrderStatusDetails();
  }

  onDealerSelected(selectedDealer: any) {
    this.dealerId = selectedDealer;
    this.workOrderStatusRequest.dealerId = selectedDealer;
    this.workOrderStatusResponseModel = [];
    this.workOrderStatusRequest.StartRecordNumber = 0;
    this.getWorkOrderStatusDetails();
  }

  onRefresh() {
    this.onDateSelectionCleared();
    this.workOrderStatusRequest.StartRecordNumber = 0;
    this.workOrderStatusRequest.SearchTerm = null;
    this.workOrderStatusRequest.dealerId = null;
    this.searchTerm = null;
    this.dealerId = null;
    this.workOrderStatusResponseModel = [];
    this.getWorkOrderStatusDetails();
  }

  onClearFilter() {
    this.onRefresh();
  }

  async onDateRangeChanged(event: any) {
    this.selectedDate = (typeof event === 'undefined') ? [] : event;
    let selectedDateFormatted= this.getFormattedDate(this.selectedDate);
    if (selectedDateFormatted === "") {
      this.onDateSelectionCleared();
    }
    this.workOrderStatusRequest.selectedDate = selectedDateFormatted;
    this.workOrderStatusResponseModel = [];
    await this.getWorkOrderStatusDetails();
  }

  onDateSelectionCleared() {
    let warningmsg = this.translate.instant("lblShowingLastMonthData");
    this.toaster.warning(warningmsg);
    const date = new Date();
    const startDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    const formattedStartDate = this.datePipe.transform(startDate, 'dd/MM/yyyy');
    const endDate = new Date();
    const formattedEndDate = this.datePipe.transform(endDate, 'dd/MM/yyyy');
    this.selectedDate=[];
    this.selectedDate.push(startDate);
    this.selectedDate.push(endDate);
    let formatted= formattedStartDate + ' - ' + formattedEndDate;
    this.workOrderStatusRequest.selectedDate = formatted;
    this.cdr.detectChanges();
  }

  onScrollDown() {
    if (this.totalCount > this.workOrderStatusResponseModel.length) {
      this.workOrderStatusRequest.StartRecordNumber = this.workOrderStatusResponseModel.length;
      this.getWorkOrderStatusDetails();
    }
  }

  async onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.workOrderStatusRequest.sortColumn = column;
    this.workOrderStatusRequest.sortDirection = direction;
    this.workOrderStatusRequest.StartRecordNumber = 0;
    this.workOrderStatusResponseModel = [];
    this.getWorkOrderStatusDetails();
  }
  //#endregion

  //#region Export Methods
  public async exportAsXLSX() {
    await this.exportData();
    if (this.workOrderStatusResponseModel.length === 0) {
      return;
    }
    this.spinner.show();
    const excelData = this.mapDataForExport();
    this.excelService.exportAsExcelFile(excelData, `${this.translate.instant('lblWorkOrderStatusReport')}`);
    this.spinner.hide();
  }

  public async exportAsPDF() {
    await this.exportData();
    if (this.workOrderStatusResponseModel.length === 0) {
      return;
    }
    this.spinner.show();
    const pdfData = this.mapDataForExport();
    const doc = new jsPDF('portrait');
    autoTable(doc, {
      head: [this.getHeadersForExport()],
      body: pdfData.map(row => Object.values(row)),
      margin: { top: 3, left: 3, right: 3, bottom: 3 },
      styles: { fontSize: 8 },
      columnStyles: {
        0: { cellWidth: 15 },
        1: { cellWidth: 30 },
        2: { cellWidth: 20 },
        3: { cellWidth: 29 },
        4: { cellWidth: 20 },
        5: { cellWidth: 30 },
        6: { cellWidth: 20, halign: 'center' },
        7: { cellWidth: 20, halign: 'center' },
        8: { cellWidth: 20, halign: 'center' }
      }
    });
    doc.save(`${this.translate.instant('lblWorkOrderStatusReport')}.pdf`);
    this.spinner.hide();
  }

  private async exportData(): Promise<void> {
    this.spinner.show();
    this.workOrderStatusRequest.isExport = true;
    await this.appointmentService.GetWorkOrderStatusDetails(this.workOrderStatusRequest).then((response) => {
      if (!response || !response.responseObject || response.responseObject.length === 0) {
        this.toaster.error(this.translate.instant('lblDataNotAvailable'));
        this.dataList = [];
        return;
      }
      this.dataList = response.responseObject;
    }).finally(() => {
      this.workOrderStatusRequest.isExport = false;
      this.spinner.hide();
    });
  }

  private mapDataForExport(): any[] {
    return this.dataList.map((item, index) => ({
      [this.translate.instant('lblNo')]: index + 1,
      [this.translate.instant('lblDealerName')]: item.dealerName,
      [this.translate.instant('lblWoNo')]: item.workOrder,
      [this.translate.instant('lblWoStatus')]: item.workOrderStatus,
      [this.translate.instant('lblStatus')]: item.status,
      [this.translate.instant('lblCreatedDate')]: item.createdDate ? this.datePipe.transform(new Date(item.createdDate + 'Z'), 'dd-MM-yyyy HH:mm', '') : null,
      [this.translate.instant('lblReservationCreated')]: item.reservation,
      [this.translate.instant('lblPurchaseOrderCreated')]: item.purchaseOrder,
      [this.translate.instant('lblSalesOrderCreated')]: item.salesOrder
    }));
  }

  private getHeadersForExport(): string[] {
    return [
      this.translate.instant('lblNo'),
      this.translate.instant('lblDealerName'),
      this.translate.instant('lblWoNo'),
      this.translate.instant('lblWoStatus'),
      this.translate.instant('lblStatus'),
      this.translate.instant('lblCreatedDate'),
      this.translate.instant('lblReservationCreated'),
      this.translate.instant('lblPurchaseOrderCreated'),
      this.translate.instant('lblSalesOrderCreated')
    ];
  }
  //#endregion

  //#region API Methods
  async getDealers() {
    this.spinner.show();
    await this.dealerBusinessService.getUserDealersDropdown().then((response) => {
      this.dealerList = this.mapDealer(response.userDealersModel);
      this.spinner.hide();
    });
  }

  mapDealer(array: UserDealersModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach((element) => {
        let single = Object();
        single.value = element.dealerId;
        single.text = element.dealerName;
        supperArray.push(single);
      });
    }
    return supperArray;
  }

  async getWorkOrderStatusDetails() {
    this.spinner.show();
    this.appointmentService.GetWorkOrderStatusDetails(this.workOrderStatusRequest).then(
      (res) => {
        if (res && res.responseObject) {
          this.totalCount = 0;
          res.responseObject.forEach((element) => {
            element.createdDate = new Date(element.createdDate + 'Z');
          })
          // res.responseObject.createdDate= new Date(res.responseObject.createdDate + 'Z');
          this.workOrderStatusResponseModel.push(...res.responseObject);
          if (this.workOrderStatusResponseModel.length > 0) {
            this.totalCount = this.workOrderStatusResponseModel[0].totalCount;
          }
        }
      }
    ).finally(() => {
      this.spinner.hide();
    });
  }
  //#endregion

  getFormattedDate(dateRangeArray: any[]){
    let formattedDate: string= "";
    if(dateRangeArray.length != 0){
      let beginDate= this.datePipe.transform(dateRangeArray[0], 'dd/MM/yyyy');
      let lastDate= this.datePipe.transform(dateRangeArray[1], 'dd/MM/yyyy');
      formattedDate= beginDate + ' - ' + lastDate;
    }
    return formattedDate;
  }
}